import { render, staticRenderFns } from "./GeetestCaptcha.vue?vue&type=template&id=513f7983&"
import script from "./GeetestCaptcha.vue?vue&type=script&lang=js&"
export * from "./GeetestCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./GeetestCaptcha.vue?vue&type=style&index=0&id=513f7983&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports